jQuery(document).ready(function ($) {
  /*----- utils -----*/
  const isMobile = () => {
    return $(window).width() <= 800;
  };


  /*----- sticky banner and elevator -----*/
  reviewTopSticker = $('.review-sticker').outerHeight();
  reviewTopHeight = $('.review-top').outerHeight();

  function addClassFixed(element) {
    if ($(element).hasClass("fixed")) {
      return;
    }

    $(element).addClass("fixed");
  };

  function removeClassFixed(element) {
    $(element).removeClass("fixed");
  };

  if ($('.page-template-partner-review')) {
    $(window).scroll(function() {
      if ($(this).scrollTop() > (reviewTopHeight +  310)
        && !isMobile() || $(this).scrollTop() > (reviewTopHeight + 130)
        && isMobile()) {
        addClassFixed('.review-sticker');
      } else {
        removeClassFixed('.review-sticker');
      }
    });
  }

  if ($(".elevator").length > 0) {
    $(window).load(function() {
      updateElevator();
    });

    createElevator();
    updateElevator();

    $(window).scroll(function() {
      scrollTop = $(this).scrollTop() + reviewTopSticker;

      $(".side_nav_item").each(function() {
        minScroll = $(this).attr("minScroll");
        maxScroll = $(this).attr("maxScroll");

        if (scrollTop > minScroll) {
          $(".side_nav_item.active").removeClass("active");
          $(this).addClass("active");
          return;
        }
      });
    });
  }

  $('.side_nav_item').on("click",function() {
    element = $('h2.showInMenu[data-count="' + $(this).attr("data-count") + '"]');
    $('.side_nav_item').removeClass('active');
    $(this).addClass('active');
    $('body,html').animate({scrollTop: element.offset().top - reviewTopSticker - 40},500);
  });

  function updateElevator() {
    $(".main h2.showInMenu").each(function(index) {
      dataCount = $(this).attr("data-count");
      minScroll = $('.main h2.showInMenu').eq(index).offset().top;
      maxScroll = 12;

      if (index < $(".main h2.showInMenu").length - 1) {
        maxScroll = $('.main h2.showInMenu').eq(index + 1).offset().top;
      }

      minScroll -= reviewTopSticker + 12;
      maxScroll -= reviewTopSticker + 12;
      $(".side_nav_item[data-count="+dataCount+"]").attr("minScroll",minScroll);
      $(".side_nav_item[data-count="+dataCount+"]").attr("maxScroll",maxScroll);
    });
  }

  function createElevator() {
    elevatorSelect = $('.elevator');

    if ($('.elevatorInner').length > 0) {
      elevatorSelect = $('.elevatorInner');
    }
    elevatorSelect.empty();

    $(".main h2.showInMenu").each(function(index) {
      increasedIndex = index + 1;
      $(this).attr("data-count", increasedIndex);
      elevatorSelect.append('<div class="side_nav_item" data-count="'+increasedIndex+'"><a href="javascript:void(0);">'+$(this).html()+'</a></div>');
    });

    $('.side_nav_item').first().addClass('active');
    elevatorSelect.show();
  }
});